import { DOCUMENT } from '@angular/common';
import { Injectable, effect, inject, signal } from '@angular/core';

const HIGH_CONTRAST_KEY = 'ucwip.highContrast';
const LARGE_TEXT_KEY = 'ucwip.largeText';

@Injectable({ providedIn: 'root' })
export class AccessibilityPreferencesService {
  private readonly document = inject(DOCUMENT);

  readonly highContrast = signal(this.readBoolean(HIGH_CONTRAST_KEY));
  readonly largeText = signal(this.readBoolean(LARGE_TEXT_KEY));

  constructor() {
    effect(() => {
      const body = this.document.body;
      body.classList.toggle('ucwip-high-contrast', this.highContrast());
      body.classList.toggle('ucwip-large-text', this.largeText());
    });
  }

  setHighContrast(enabled: boolean): void {
    this.highContrast.set(enabled);
    this.persist(HIGH_CONTRAST_KEY, enabled);
  }

  setLargeText(enabled: boolean): void {
    this.largeText.set(enabled);
    this.persist(LARGE_TEXT_KEY, enabled);
  }

  private readBoolean(key: string): boolean {
    try {
      if (typeof localStorage !== 'undefined' && typeof localStorage.getItem === 'function') {
        return localStorage.getItem(key) === 'true';
      }
    } catch {
      // jsdom / SSR may expose a partial localStorage stub.
    }
    return false;
  }

  private persist(key: string, value: boolean): void {
    try {
      if (typeof localStorage !== 'undefined' && typeof localStorage.setItem === 'function') {
        localStorage.setItem(key, String(value));
      }
    } catch {
      // ignore persistence failures in test/SSR environments
    }
  }
}
